import styled from 'styled-components';


export const BlogTitleBox = styled.div`
    display: flex;
    align-items: center; 
    justify-content: space-between;
    margin-bottom: 20px;
`;
export const BlogTitleText = styled.h2`
    font-family: "Jost", sans-serif;
    font-size: 36px;
    font-weight: bold;
    line-height: 52px;
    color: #333333;
    @media screen and (max-width:1199px) { 
        font-size: 32px;
        line-height:40px;
    }
    @media screen and (max-width:991px) { 
        font-size: 30px;
        line-height:40px;
    }
    @media screen and (max-width:767px) { 
        font-size: 25px;
        line-height: 30px;
    }
`;
export const BlogTitleButton = styled.div`
    button{
        padding: 13px 30px;
        
        @media screen and (max-width:767px) { 
            padding: 8px 15px;
        }
    }
`;

export const BlogCardCamp = styled.div`
   margin-bottom: 30px;

    &:last-child{
        margin-bottom: 0px;
    }
    .card {
        position: relative;
        border-radius: 20px;
        width: 100%;
          border: none;;
        
     @media screen and (max-width:767px) { 
            border-radius: 15px;
        }
    }
       
`;
export const CardImageBody = styled.div`
    width: 100%;
    height: auto;
    display: block;
    position: relative;
    padding-bottom: 77.9%;
    margin: 0;
    border-radius: 20px;
    @media screen and (max-width: 767px){
        border-radius: 15px;
    }
    .card-img{
        width: 100%;
      }
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
       left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius:  20px 20px 0px 0px;
     }    
`;
export const CardTextBody = styled.div`
   

    .card-body{
        box-shadow: 0px 5px 30px #0000001A;
        border-radius: 0px 0px 20px 20px;
        background: #fff;
        padding: 30px;
        min-height: 270px;

        @media screen and (max-width:767px) { 
            padding: 20px;
            border-radius: 15px;
        } 
        @media screen and (max-width:480px) { 
            padding: 15px;
        }

        .card-title {
            font-family: "Jost", sans-serif;
            font-size: 22px;
            font-weight: 600;
            line-height: 30px;
            margin-bottom: 15px;
            color: #333333;
            cursor: pointer;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            @media screen and (max-width:767px) { 
                font-size: 16px;
                line-height: 25px; 
            }

            @media screen and (max-width:480px){
                margin-bottom: 10px;
            }
        }
        .card-text{
            font-family: "Jost", sans-serif;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            color: rgba(51, 51, 51, 0.8);
            max-width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 0px;
        }
    }
`;
export const CardDate = styled.span`
    display: block;
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 15px;
`;
export const StrongText = styled.span`
    font-weight: bold;
    cursor: pointer;
`;
export const DotText = styled.span``;
export const CardButton = styled.div`
    display: none;
`;